import React from "react";
import { useLocation } from "react-router-dom";
import { TopFixedMenu } from "./TopFixedMenu";
import { BottomFixedMenu } from "./BottomFixedMenu";

export const MobileMenuWrapper: React.FC = () => {
  const location = useLocation();
  
  // Determine if we're in a panel route
  const isAdmin = location.pathname.startsWith('/painel-admin');
  const isMentor = location.pathname.startsWith('/painel-mentor');
  const isPlayer = location.pathname.startsWith('/painel-jogador');
  const isPanel = isAdmin || isMentor || isPlayer;
  
  // Don't show on auth pages or non-panel routes
  const noMenuPages = ['/login', '/cadastro', '/recuperar-senha', '/auth/callback'];
  const shouldShowMenus = isPanel && !noMenuPages.some(page => location.pathname.startsWith(page));
  
  if (!shouldShowMenus) return null;

  return (
    <>
      {/* Top menu - Panel navigation */}
      <TopFixedMenu />
      
      {/* Bottom menu - General navigation */}
      <BottomFixedMenu />
    </>
  );
}; 